module.exports = __webpack_public_path__ + "static/media/icon_instrument_ukelele.acdf10f1.svg";